import React, {useEffect, useState} from 'react';
import {Col, Row} from 'reactstrap';

import ToDoTaskList from "./_list";
import ToDoTaskForm from "./_form";

export default function ToDoTask() {
    const [collapseForm, setCollapseForm] = useState(false);
    const [item, setItem] = useState();

    useEffect(() => {
        const selectedItem = JSON.parse(localStorage.getItem('notificationItem'));
        if (selectedItem){
            beginEdit(selectedItem);
            localStorage.removeItem('notificationItem');
        }
    }, []);

    const toggleForm = () => {
        setCollapseForm(!collapseForm);
        setItem(null);
    }

    const showForm = (data) => {
        setCollapseForm(!collapseForm);
        setItem(data);
    }

    const beginEdit = (data) => {
        setCollapseForm(!collapseForm);
        setItem(data);
    }

    return <Row>
        <Col>
            {
                !collapseForm
                    ? <ToDoTaskList beginEdit={showForm}/>
                    : <ToDoTaskForm toggleParent={toggleForm} item={item} beginEdit={beginEdit}/>
            }
        </Col>
    </Row>
}